import jqRequest from '../jqRequest'
import videoUrls from '../urls/video'

export default {
  // 获取视频详情
  getVideoDetailById(data) {
    return jqRequest.requestWithToken(videoUrls.getVideoDetailById, data);
  },
}